import { createUseStyles } from 'react-jss'
import { forPhoneOnly } from 'src/config/mediaQueries'

export default createUseStyles({
  animationContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  animation: {
    width: 229,
    height: 'auto',
    [forPhoneOnly]: {
      width: 159,
    },
  },
})
